module.exports = __webpack_public_path__ + "img/img.ffbdb26f.png";